import { Fragment } from 'react';

import { useSelector } from 'react-redux';

import { getIsFastActionPage } from '@/main/components/Table/utils/tableUtils';
import { Button, InfoBlock, LinkBlock } from '@components/common';
import { FormBlockStyled } from '@components/common/FormStyled/FormStyled';
import {
    getPageInquiryInfoUrl,
    isPageInquiryInfoExternalUrl,
} from '@pages/PageInquiryInfo';
import { RoutePath } from '@routes/constants/routesConstants';
import { stringFormatParamsHtml } from '@utils/stringFormat';

import { openRoute } from '../../../routes/constants/externalRoutes';
import { EColorStatus } from '../../app/appConstants';
import {
    makeSelectCreateInquiryTranslation,
    makeSelectTranslationCommon,
} from '../../internationalization/intSelectors';
import Modal from '../../modal/components/Modal';
import type { IModalRenderProps } from '../../modal/types/modalTypes';
import { makeSelectGuardComponents } from '../../role';

interface ICreateInquiryModalSuccess extends Pick<IModalRenderProps, 'onCloseModal'> {
    fileAttachedWithErrors?: boolean;
    id?: string;
}

const CreateInquiryModalSuccess = ({ fileAttachedWithErrors, id, onCloseModal }: ICreateInquiryModalSuccess) => {

    const componentsFeature = useSelector(makeSelectGuardComponents());

    const translationCommon = useSelector(makeSelectTranslationCommon());
    const { success: tInquirySuccess } = useSelector(makeSelectCreateInquiryTranslation());
    const isFastActionPage = getIsFastActionPage();

    const onClickHandler = () => {
        onCloseModal();
        if (isFastActionPage) {
            openRoute(RoutePath.dashboard);
        }
    }

    return (
        <Fragment>
            <Modal.Title>
                {tInquirySuccess.title}
            </Modal.Title>
            {!!id && (
                <FormBlockStyled>
                    <Modal.Text>
                        {stringFormatParamsHtml(tInquirySuccess.inquiryId, {
                            inquiry: <LinkBlock
                                isExternalUrl={isPageInquiryInfoExternalUrl(componentsFeature)}
                                url={getPageInquiryInfoUrl(componentsFeature, id)}
                            >
                                {id}
                            </LinkBlock>,
                        })}
                    </Modal.Text>
                </FormBlockStyled>
            )}

            <FormBlockStyled>
                <Modal.Text>
                    {
                        stringFormatParamsHtml(tInquirySuccess.inquiryList, {
                            inquiry: <LinkBlock url={RoutePath.inquiries}>
                                {translationCommon.pages.inquiry}
                            </LinkBlock>,
                        })
                    }
                </Modal.Text>
            </FormBlockStyled>

            {
                !!fileAttachedWithErrors && (
                    <FormBlockStyled>
                        <InfoBlock colorStatus={EColorStatus.WARNING}>
                            {tInquirySuccess.fileAttachedWithErrors}
                        </InfoBlock>
                    </FormBlockStyled>
                )
            }
            <Modal.Control>
                <Button onClick={onClickHandler}>
                    {translationCommon.modal.good}
                </Button>
            </Modal.Control>
        </Fragment>
    );
};

export default CreateInquiryModalSuccess;
